import React from 'react';

/**
 * Griglia agenda medico (giorno/settimana) — mockup 04.
 * Il parent gestisce dati, drag e stile CSS (.medico-agenda__*).
 */
export function WeekCalendar({
  days = [],
  rows = 12,
  hourStart = 8,
  toIsoDate,
  freeBlocks = [],
  appointmentBlocks = [],
  drag = null,
  selectedId = null,
  formatSlotTime,
  shortPatientName,
  spanRows,
  onCellMouseDown,
  onCellMouseEnter,
  onSelectAppointment,
  className = '',
}) {
  const dayCount = days.length || 1;

  return (
    <div
      className={`medico-agenda__grid ${className}`.trim()}
      style={{
        gridTemplateColumns: `56px repeat(${dayCount}, minmax(0, 1fr))`,
        gridTemplateRows: `48px repeat(${rows}, 42px)`,
      }}
    >
      {days.map((d, i) => (
        <div key={toIsoDate(d)} className="medico-agenda__day-head" style={{ gridColumn: i + 2, gridRow: 1 }}>
          {d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric' })}
        </div>
      ))}
      {Array.from({ length: Math.ceil(rows / 2) }, (_, i) => (
        <div
          key={`h-${i}`}
          className="medico-agenda__hour"
          style={{ gridColumn: 1, gridRow: 2 + i * 2 }}
        >
          {hourStart + i}:00
        </div>
      ))}

      {freeBlocks.map((b) => {
        const { startRow, endRow } = spanRows(b.start, b.end);
        return (
          <div
            key={b.key}
            className={`medico-agenda__free medico-agenda__free--${(b.modalita || 'VIDEO').toLowerCase()}`}
            style={{ gridColumn: b.dayIndex + 2, gridRow: `${startRow} / ${endRow}` }}
          >
            {b.label}
          </div>
        );
      })}

      {appointmentBlocks.map(({ app, dayIndex, start, end }) => {
        const { startRow, endRow } = spanRows(start, end);
        const name = app.pazienteNome || `Paziente #${app.idPaziente}`;
        const active = selectedId === app.id;
        return (
          <button
            key={app.id}
            type="button"
            className={`medico-agenda__appt${active ? ' is-selected' : ''}`}
            style={{ gridColumn: dayIndex + 2, gridRow: `${startRow} / ${endRow}` }}
            onClick={() => onSelectAppointment?.(app)}
          >
            <strong>{end - start >= 45 ? name : shortPatientName(name)}</strong>
            <span>
              {formatSlotTime(app.oraInizio)}
              {app.prestazione ? ` · ${app.prestazione}` : ''}
            </span>
          </button>
        );
      })}

      {days.map((_, dayIndex) =>
        Array.from({ length: rows }, (_, rowIndex) => {
          const inDrag = drag
            && drag.dayIndex === dayIndex
            && rowIndex >= Math.min(drag.startRow, drag.endRow)
            && rowIndex <= Math.max(drag.startRow, drag.endRow);
          return (
            <div
              key={`cell-${dayIndex}-${rowIndex}`}
              className={`medico-agenda__cell${inDrag ? ' is-drag' : ''}`}
              style={{ gridColumn: dayIndex + 2, gridRow: rowIndex + 2 }}
              onMouseDown={(e) => onCellMouseDown?.(dayIndex, rowIndex, e)}
              onMouseEnter={() => onCellMouseEnter?.(dayIndex, rowIndex)}
            />
          );
        })
      )}
    </div>
  );
}
